import { API } from '../Api';

// Quỹ Ca đào của clan (payment-service). Response trả trần, auid gateway tự gắn.
const BASE = '/v1/payment-service/clan-treasury';

export type ClanTreasuryTxType = 'DEPOSIT' | 'ARENA_REWARD' | 'PAYOUT';
export type ClanProposalStatus = 'PENDING' | 'APPROVED' | 'REJECTED' | 'EXPIRED';

export interface ClanTreasuryTx {
  id: string;
  type: ClanTreasuryTxType | string;
  amount: number;
  userId?: string | null;
  challengeId?: string | null;
  proposalId?: string | null;
  note?: string | null;
  createdAt: string;
}

export interface ClanTreasuryProposal {
  id: string;
  clanId: string;
  toUserId: string;
  amount: number;
  reason: string;
  createdBy: string;
  status: ClanProposalStatus | string;
  createdAt: string;
  expiresAt: string;
  decidedAt?: string | null;
  approveCount: number;
  rejectCount: number;
  myVote?: boolean | null;
}

export interface ClanTreasury {
  clanId: string;
  clanName: string;
  balance: number;
  myRole: string;
  captainCount: number;
  transactions: ClanTreasuryTx[];
  proposals: ClanTreasuryProposal[];
}

export const getClanTreasury = () => API.get<ClanTreasury>(BASE).then((r) => r.data);

export const depositClanTreasury = (amount: number) =>
  API.post<{ balance: number; minedCaAfter: number }>(`${BASE}/deposit`, { amount }).then((r) => r.data);

export const createClanProposal = (toUserId: string, amount: number, reason: string) =>
  API.post<ClanTreasuryProposal>(`${BASE}/proposals`, { toUserId, amount, reason }).then((r) => r.data);

export const voteClanProposal = (id: string, approve: boolean) =>
  API.post<ClanTreasuryProposal>(`${BASE}/proposals/${id}/vote`, { approve }).then((r) => r.data);

// Lấy câu báo lỗi tiếng Việt từ response của payment-service nếu có.
export const treasuryErrorMessage = (e: any, fallback = 'Không thực hiện được'): string =>
  e?.response?.data?.message || e?.response?.data?.title || e?.message || fallback;
